import { DISCOVER_DEFAULT_TECHNICAL_ERROR_KEY } from 'components/discover/shared';
import { FC } from 'react';
import styled from 'styled-components';

import { ErrorWithRetry } from '../../../shared/ErrorWithRetry';

interface TechnicalErrorProps {
  retry: () => void;
}

const FixedHeightDiv = styled.div`
  height: 75vh;
`;
export const SeeMoreTechnicalError: FC<TechnicalErrorProps> = ({ retry }) => (
  <FixedHeightDiv className="d-flex align-items-center mx-5">
    <ErrorWithRetry onRetry={retry} className="py-4" msgKey={DISCOVER_DEFAULT_TECHNICAL_ERROR_KEY} />
  </FixedHeightDiv>
);
